import { useMutation, useQueryClient } from 'react-query';
import { PAYMENT_QUERY_KEY } from './usePaymentQuery';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

const deletePayment = (clientId: string) => {
  return authFetch('/Consumer/BluePay/DeletePaymentInformation', {
    method: 'DELETE',
    ...httpBodyOptions({ clientId }),
  });
};

export const useDeletePaymentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(deletePayment, {
    onSuccess(data, clientId) {
      queryClient.invalidateQueries([PAYMENT_QUERY_KEY, clientId]);
    },
  });
};
